import Fuse from 'fuse.js'

const options = {
  threshold: 0.6,
  location: 0,
  distance: 100,
  maxPatternLength: 32,
  minMatchCharLength: 1,
}

function filterByObjectValues<T>(
  list: T[],
  keys: string[],
  search: string,
): T[] {
  const fuse = new Fuse(list, { ...options, keys })
  const results = fuse.search(search)

  return results.map(result => result.item)
}

export { filterByObjectValues }
